import moment from "moment";

import { getCurrentReportingValues } from "utils";

import { CarbonProgram } from "models";

export const calculateImpactPanelBodyHeight = () => {
  const headerDesktop = document.querySelector(".header-desktop.container");
  const impactPanelHeader = document.querySelector(".field-timeline-impact-panel.header");

  const headerDesktopHeight = headerDesktop ? headerDesktop.getBoundingClientRect().height : 0;
  const impactPanelHeaderHeight = impactPanelHeader ? impactPanelHeader.getBoundingClientRect().height : 0;

  const bodyHeightRem = (window.innerHeight - headerDesktopHeight - impactPanelHeaderHeight - 1) / 16;

  return bodyHeightRem;
};

export const getTimelineDefaultStartAndEnd = (
  farmReportingYearData: number | undefined,
  carbonProgram: CarbonProgram | null,
  screenSize: "small" | "medium" | "large" = "large"
): { start: number; end: number } => {
  const { startDate: reportingPeriodStartDate } = getCurrentReportingValues(farmReportingYearData ?? moment().year(), carbonProgram);
  const startDate = reportingPeriodStartDate || moment().startOf("year");
  const monthsToSubtractToStart = screenSize === "small" ? 2 : screenSize === "medium" ? 4 : 6;
  const timelineLengthInMonths = screenSize === "small" ? 12 : screenSize === "medium" ? 18 : 24;
  const timelineLengthInMilliseconds = moment.duration(timelineLengthInMonths, "months").asMilliseconds();

  return {
    start: startDate.clone().subtract(monthsToSubtractToStart, "months").valueOf(),
    end: startDate.clone().add(timelineLengthInMilliseconds).valueOf(),
  };
};
